import React,{useState} from 'react';
import Footer from '../components/Footer';
import Navbar2 from '../components/Navbar2';
import Sidebar from '../components/Sidebar';
import SignIn from '../components/SignIn';




function SignInPage() {
    const user = "Amal";
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    return (
        <div>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar2 toggle={toggle} log={user} />  
            <SignIn log={user} />


            <Footer />
        </div>
    )
}

export default SignInPage